import InvoiceAutomationJobMonthRuleEnum from './InvoiceAutomationJobMonthRuleEnum';

// Which month a job belongs to; each label completes "A job belongs to the month…".
const InvoiceAutomationJobMonthRuleOptionsArray = [
  { label: 'Its shop date falls in', value: InvoiceAutomationJobMonthRuleEnum.DateDone },
  { label: 'Its Prism run started in', value: InvoiceAutomationJobMonthRuleEnum.PrismRunStart },
  { label: 'It becomes Ready for Invoicing in', value: InvoiceAutomationJobMonthRuleEnum.DateAdded },
];

export default InvoiceAutomationJobMonthRuleOptionsArray;
